import { render, staticRenderFns } from "./ProviderDashboard.vue?vue&type=template&id=32870bd3"
import script from "./ProviderDashboard.vue?vue&type=script&lang=js"
export * from "./ProviderDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports